import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEqual } from "lodash";
import moment from "moment";
import { DatePicker, Popconfirm } from "antd";
import ReactTable from "react-table";
import MerchandiserInvoicingStatuses from "data/merchandiser-invoicing-statuses";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import CustomCheckbox from "components/custom/forms/custom-checkbox";
import statusFilter from "components/menu/invoicing/merchandiser/status-filter";
import { Button } from "react-bootstrap";

class ListChargesMisc extends Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.tableRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        if (!isEqual(nextProps.miscCharges, this.props.miscCharges)) {
            return true;
        } else if (!isEqual(nextProps.selectedMiscCharges, this.props.selectedMiscCharges)) {
            return true;
        } else if (nextProps.isAdminView !== this.props.isAdminView) {
            return true;
        }
        return false;
    }

    getColumns = () => {
        const {
            isAdminView,
            miscCharges,
            selectedMiscCharges
        } = this.props;

        const columns = [];

        if (isAdminView) {
            columns.push({
                Cell: ({ original }) => (
                    <CustomCheckbox
                        key={original.chargeId}
                        className="checkbox"
                        checked={selectedMiscCharges[original.chargeId] === true}
                        onChange={() => this.props.onToggle(original.chargeId)}
                    />
                ),
                headerClassName: "text-left",
                Header: () => (
                    <input
                        type="checkbox"
                        className="checkbox"
                        checked={Object.keys(selectedMiscCharges).length === miscCharges.length
                            && Object.keys(selectedMiscCharges).length}
                        ref={input => {
                            if (input) {
                                const selectedCount = Object.keys(selectedMiscCharges).length;
                                input.indeterminate = miscCharges.length > selectedCount
                                    && selectedCount > 0;
                            }
                        }}
                        onChange={() => this.props.onToggle(false, this.tableRef)}
                    />
                ),
                sortable: false,
                filterable: false,
                resizable: false,
                minResizeWidth: 40,
                width: 40,
                className: "d-flex justify-content-center align-items-center"
            });
        }
        if (isAdminView || this.props.isAccountManagerView) {
            columns.push({
                id: "merchandiser",
                Header: "Merchandiser",
                accessor: "merchandiser"
            });
            columns.push({
                Header: "Cat.",
                accessor: "category",
                id: "category",
                width: 50
            });
        }
        columns.push({
            id: "dateEntered",
            Header: "Date",
            // accessor: "completedDate",
            accessor: original => moment(original.dateEntered)
                .format(this.dateFormat),
            Filter: ({
                         filter,
                         onChange
                     }) => (
                <DatePicker
                    Format={this.dateFormat}
                    value={filter ? filter.value : null}
                    onChange={date => onChange(date)}
                />
            )
        });
        columns.push({
            id: "description",
            Header: "Description",
            accessor: original => {
                if (original.travelChargeType && original.travelChargeType.toLocaleLowerCase() === "km") {
                    return `${original.description}  ${original.units ? ` - ${original.units} km` : ""}`;
                } else if (original.travelChargeType && original.travelChargeType.toLocaleLowerCase() === "time") {
                    return `${original.description}  ${original.units ? ` - ${original.units} hr` : ""}`;
                } else if (original.travelChargeType && original.travelChargeType.toLocaleLowerCase() === "cont") {
                    return `${original.description} Continuity`;
                } else if (original.travelChargeType && original.travelChargeType.toLocaleLowerCase() === "flat") {
                    return `${original.description} Flat`;
                } else {
                    return original.description;
                }
            }
        });
        columns.push({
            id: "allJobs",
            Header: "Job(s)",
            accessor: "allJobs",
        });
        columns.push({
            id: "totalHours",
            Header: "Total Hours",
            accessor: "billableHours",
        });
        columns.push({
            id: "comments",
            Header: "Comments",
            accessor: "comments",
        });
        columns.push({
            id: "amount",
            Header: "Amount",
            accessor: "amount",
            Filter: ({
                         filter,
                         onChange
                     }) => (
                <input
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ""}
                    className="form-control"
                    type="number"
                />
            )
        });
        columns.push({
            id: "approvalStatus",
            Header: "Status",
            accessor: "approvalStatus",
            Cell: ({ original }) => (
                <div
                    className="text-center"
                    style={{
                        color: MerchandiserInvoicingStatuses[original.approvalStatus].color
                    }}
                >
                    {MerchandiserInvoicingStatuses[original.approvalStatus].icon}
                </div>
            ),
            Filter: statusFilter
        });
        columns.push({
            id: "misc-actions",
            Header: "Actions",
            Cell: ({ original }) => {
                const chargeId = original.chargeId;
                const merchandiserId = original.merchandiserId;

                return (
                    this.props.isMerchandiserView && original.approvalStatus === "ApprovedByManager" ? null :
                        (<div className="d-flex justify-content-around">
                            {this.props.isAccountManagerView ? null :
                                (<button
                                    className="btn btn-sm btn-warning mr-2"
                                    onClick={() => this.props.onEdit(chargeId, merchandiserId)}
                                >
                                    Edit
                                </button>)}

                            <Popconfirm
                                title={"Delete Miscellaneous Charge?"}
                                onConfirm={() => this.props.onDelete(chargeId)}
                                placement="topRight"
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button className="btn btn-sm btn-danger">
                                    Delete
                                </Button>
                            </Popconfirm>
                        </div>)
                );
            },
            Filter: () => false
        });

        return columns.map(value => {
            value.headerClassName = "text-left";
            return value;
        });
    };

    render() {
        const {
            miscCharges,
            isAccountManagerView
        } = this.props;

        return (
            <div>
                <div className="mb-2">
                    {isAccountManagerView ? null :
                        (<button className="btn btn-sm btn-success"
                                 onClick={() => this.props.onEdit()}>New Misc Charge
                        </button>)}
                </div>
                <ReactTable
                    ref={this.tableRef}
                    data={miscCharges}
                    columns={this.getColumns()}
                    headerClassName="table-header"
                    showPagination={false}
                    pageSize={Math.max(miscCharges.length, 20)}
                    resizable
                    className="-striped -highlight"
                    filterable
                    defaultSorted={[
                        {
                            id: "dateEntered",
                            desc: false
                        }
                    ]}
                    defaultFilterMethod={filterCaseInsensitive}
                    getNoDataProps={() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 250px)",
                    }}
                />
            </div>
        );
    }
}

ListChargesMisc.propTypes = {
    miscCharges: PropTypes.array.isRequired,
    selectedMiscCharges: PropTypes.object.isRequired,
    isAdminView: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
};

export default ListChargesMisc;
